import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

// When the server refuses an advisor's change (403 VIEW_ONLY), say so plainly
// on whatever dashboard they are on, instead of each screen's generic
// "could not save" message. Mounted once at the app root.
const ViewOnlyNotice = () => {
  const { t } = useTranslation();
  const [shownAt, setShownAt] = useState(0);

  useEffect(() => {
    let last = 0;
    const id = axios.interceptors.response.use(undefined, (error) => {
      if (error.response?.status === 403 && error.response?.data?.code === 'VIEW_ONLY' && Date.now() - last > 3000) {
        last = Date.now();
        setShownAt(last);
      }
      return Promise.reject(error);
    });
    return () => axios.interceptors.response.eject(id);
  }, []);

  useEffect(() => {
    if (!shownAt) return undefined;
    const timer = setTimeout(() => setShownAt(0), 5000);
    return () => clearTimeout(timer);
  }, [shownAt]);

  if (!shownAt) return null;
  return (
    <div role="alert" style={{
      position: 'fixed', left: '50%', bottom: 24, transform: 'translateX(-50%)', zIndex: 7000,
      maxWidth: 'calc(100vw - 32px)', padding: '0.7rem 1rem', borderRadius: 12,
      background: '#fffbeb', border: '1px solid #fde68a', color: '#92400e',
      fontSize: '0.88rem', fontWeight: 600, boxShadow: '0 10px 30px rgba(15,23,42,0.18)',
    }}>
      {t('advisor.refused')}
    </div>
  );
};

export default ViewOnlyNotice;
